document.addEventListener("DOMContentLoaded", () => {
  const now = new Date();

  const wrapper = document.querySelector('.trial_participation');
  if (!wrapper) return;

  const container = wrapper.querySelector('.cnt_inner');
  if (!container) return;

  /**
   * コメントマーカーの対応形式：
   * - <!-- 2026-02-03~start --> / <!-- 2026-02-03~end -->
   * - <!-- 2026-02-03 18:00~start --> / <!-- 2026-02-03 18:00~end -->
   * - <!-- 2026-02-03T18:00~start --> / <!-- 2026-02-03T18:00~end -->
   * - <!-- 2026-02-03_18-00~start --> / <!-- 2026-02-03_18-00~end -->
   */
  const parseMarker = (text) => {
    const match = text.trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T\s_](\d{1,2})(?::|-)?(\d{2}))?~(start|end)$/);
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const hasTime = match[4] !== undefined;
    const hour = hasTime ? Number(match[4]) : 23;
    const minute = hasTime ? Number(match[5]) : 59;
    const second = hasTime ? 0 : 59;
    const millisecond = hasTime ? 0 : 999;
    const endAt = new Date(year, month - 1, day, hour, minute, second, millisecond);

    const pad = (num) => String(num).padStart(2, '0');
    const key = `${year}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)}`;

    return {
      type: match[6],
      key,
      endAt
    };
  };

  const hasMatchingEndMarker = (element, key) => {
    if (!element) return false;

    const iterator = document.createNodeIterator(element, NodeFilter.SHOW_COMMENT, null, false);
    let node;

    while (node = iterator.nextNode()) {
      const marker = parseMarker(node.nodeValue);
      if (marker && marker.type === 'end' && marker.key === key) {
        return true;
      }
    }

    return false;
  };

  const hasStartMarker = (element) => {
    if (!element) return false;

    const iterator = document.createNodeIterator(element, NodeFilter.SHOW_COMMENT, null, false);
    let node;

    while (node = iterator.nextNode()) {
      const marker = parseMarker(node.nodeValue);
      if (marker && marker.type === 'start') {
        return true;
      }
    }

    return false;
  };

  const iterator = document.createNodeIterator(container, NodeFilter.SHOW_COMMENT, null, false);
  const sections = [];
  let node;

  while (node = iterator.nextNode()) {
    const marker = parseMarker(node.nodeValue);
    if (!marker || marker.type !== 'start') continue;

    let startEl = node.parentElement;

    if (startEl && startEl.previousElementSibling && startEl.previousElementSibling.classList.contains('date')) {
      startEl = startEl.previousElementSibling;
    }

    if (!startEl) continue;

    const elements = [startEl];
    let next = startEl.nextElementSibling;

    while (next) {
      elements.push(next);

      if (hasMatchingEndMarker(next, marker.key)) break;

      if (hasStartMarker(next)) {
        elements.pop();
        break;
      }

      next = next.nextElementSibling;
    }

    sections.push({
      endAt: marker.endAt,
      elements
    });
  }

  sections.sort((a, b) => a.endAt - b.endAt);

  let foundNext = false;

  sections.forEach(section => {
    if (now >= section.endAt) {
      section.elements.forEach(el => el.remove());
    } else {
      if (!foundNext) {
        foundNext = true;
      } else {
        section.elements.forEach(el => el.remove());
      }
    }
  });

  if (!foundNext) {
    if (!container.querySelector('.date')) {
      const newDateP = document.createElement('p');
      newDateP.className = 'date';
      newDateP.textContent = "次回日程調整中";
      container.prepend(newDateP);
    }
  }
});
